var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useCallback, useRef, useState } from 'react';
import AntdTooltip from 'antd/es/tooltip';
import classNames from 'classnames';
import usePrefixCls from '../hooks/usePrefixCls';
const Tooltip = forwardRef((_a, ref) => {
    var { overlayStyle, overlayClassName, onVisibleChange, visible: outerVisible, ellipsisLine = 1, maxWidth = 480, type = 'tooltip', size = 'middle', prefixCls: customizePrefixCls, onVisibleChangeToParent } = _a, rest = __rest(_a, ["overlayStyle", "overlayClassName", "onVisibleChange", "visible", "ellipsisLine", "maxWidth", "type", "size", "prefixCls", "onVisibleChangeToParent"]);
    const { color, title, children = '' } = rest;
    const [visible, setVisible] = useState(false);
    const parentRef = useRef(null);
    const childRef = useRef(null);
    const isSingleLineEllipsis = ellipsisLine <= 1; // 是否单行省略
    const prefixCls = usePrefixCls('tooltip', customizePrefixCls);
    const newOverlayStyle = Object.assign(Object.assign({}, overlayStyle), { maxWidth: maxWidth });
    const overlayClassNames = classNames(`${prefixCls}`, `${prefixCls}-${size}`, {
        [`${prefixCls}-ellipsis`]: type === 'ellipsisTooltip',
        [`${prefixCls}-${color}`]: !!color
    }, overlayClassName);
    const handleVisibleChange = useCallback((val) => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (type === 'tooltip')
            return;
        const parentWidth = ((_b = (_a = parentRef === null || parentRef === void 0 ? void 0 : parentRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) === null || _b === void 0 ? void 0 : _b.width) || 0;
        const childWidth = ((_d = (_c = childRef === null || childRef === void 0 ? void 0 : childRef.current) === null || _c === void 0 ? void 0 : _c.getBoundingClientRect()) === null || _d === void 0 ? void 0 : _d.width) || 0;
        const parentHeight = ((_f = (_e = parentRef === null || parentRef === void 0 ? void 0 : parentRef.current) === null || _e === void 0 ? void 0 : _e.getBoundingClientRect()) === null || _f === void 0 ? void 0 : _f.height) || 0;
        const childHeight = ((_h = (_g = childRef === null || childRef === void 0 ? void 0 : childRef.current) === null || _g === void 0 ? void 0 : _g.getBoundingClientRect()) === null || _h === void 0 ? void 0 : _h.height) || 0;
        if (isSingleLineEllipsis) {
            setVisible(childWidth > parentWidth ? val : false);
        }
        if (!isSingleLineEllipsis) {
            setVisible(childHeight > parentHeight ? val : false);
        }
        onVisibleChangeToParent === null || onVisibleChangeToParent === void 0 ? void 0 : onVisibleChangeToParent(isSingleLineEllipsis ? childWidth > parentWidth : childHeight > parentHeight);
    }, [isSingleLineEllipsis, type]);
    const props = Object.assign({ ref, overlayStyle: newOverlayStyle, overlayClassName: overlayClassNames, onVisibleChange: type === 'tooltip' ? onVisibleChange : handleVisibleChange, visible: type === 'tooltip' ? outerVisible : visible, className: `${prefixCls}-${size}` }, rest);
    return (React.createElement(AntdTooltip, Object.assign({}, props), type === 'tooltip' ? (children) : (React.createElement("div", { ref: parentRef, className: `${prefixCls}-ellipsis-content-${isSingleLineEllipsis ? 'single' : 'multi'}`, style: isSingleLineEllipsis ? {} : { WebkitLineClamp: ellipsisLine } },
        React.createElement("span", { ref: childRef }, children ? children : title)))));
});
export default Tooltip;
